$(function () {
    $(".ar-team-listing-block .team-member").each(function (index, element) {
        var dialog = $(element).children("dialog")[0];

        //open
        $(element).children(".team-member__image-container").on("click", function () {
            dialog.showModal();
        });

        //close
        dialog.addEventListener("click", function (event) {
            if (event.target === dialog) {
                dialog.close();
            }
        });
    });

});